export default [
    //{ text : "Ivy (IA)", value : 1},
    { text : "Conversational", value : 1},
    { text : "Worksheet", value : 3},
    { text : "MCP", value : 4}
]